"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DRAWER_ITEM_TYPE = exports.DRAWER_GROUP_TYPE = exports.DRAWER_TYPE = void 0;
exports.DRAWER_TYPE = "DRAWER";
exports.DRAWER_GROUP_TYPE = "DRAWER_GROUP";
exports.DRAWER_ITEM_TYPE = "DRAWER_ITEM";
